import { ScheduleDetailsSection } from './sections/scheduleDetails/ScheduleDetails'
import { ScheduleInvoicesSection } from './sections/ScheduleInvoicesSection'
import { SchedulePricingSection } from './sections/schedulePricing/SchedulePricingSection'
import { SecheduleTimelineSection } from './sections/ScheduleTimelineSection'
import { ScheduleAttachmentsSection } from './sections/ScheduleAttachmentsSection'
import { GreyWhite, Box, Grid, GridItem } from '@sequencehq/core-components'
import { ScheduleInvoiceSummaryStats } from './sections/invoiceSummaryStats/ScheduleInvoiceSummaryStats'
import { ScheduleCreditGrantsSection } from 'CreditGrants/index'
import { useBillingScheduleId } from 'BillingScheduleHome/utils/useBillingScheduleId'
import { useFeatureFlags } from 'hooks/useFeatureFlags'

export const BillingScheduleHomeContent = () => {
  const billingScheduleId = useBillingScheduleId()
  const { useCreditGrantLedger } = useFeatureFlags()

  return (
    <Grid
      templateAreas={`"sections" "timeline"`}
      templateRows="1fr auto"
      justifyItems="center"
      height="100%"
      overflow="hidden"
      data-testid="schedule.home"
    >
      <Grid
        overflow="auto"
        gridArea="sections"
        templateColumns="1fr 1024px 1fr"
        templateAreas={`". content ."`}
        height="100%"
        width="100%"
        background={GreyWhite}
      >
        <GridItem
          padding="16px"
          width="1024px"
          display="flex"
          flexDirection="column"
          gap="20px"
          gridArea="content"
          paddingBottom="128px"
        >
          <Box paddingTop="8px">
            <ScheduleInvoiceSummaryStats />
          </Box>
          <ScheduleDetailsSection />
          <SchedulePricingSection />
          {useCreditGrantLedger && (
            <ScheduleCreditGrantsSection scheduleId={billingScheduleId} />
          )}
          <ScheduleInvoicesSection />
          <ScheduleAttachmentsSection />
        </GridItem>
      </Grid>
      <GridItem gridArea="timeline" width="100%" overflow="visible">
        <SecheduleTimelineSection />
      </GridItem>
    </Grid>
  )
}
